export default __webpack_public_path__ + "a14c6990de4ff1ac82b9a3fa293051c4.ttf";